const API_URL: string = import.meta.env.REACT_APP_API_URL
const BOUNCE_COUNT_KEY = "overmap.loginBounceCount"
const MAX_BOUNCES = 3

function absoluteUrl(returnTo?: string): string {
	return new URL(returnTo ?? window.location.href, window.location.origin).href
}

export function buildLoginUrl(returnTo?: string): string {
	return `${API_URL}/accounts/login/?next=${encodeURIComponent(absoluteUrl(returnTo))}`
}

export function buildLogoutUrl(): string {
	return `${API_URL}/accounts/logout/?next=${encodeURIComponent(window.location.origin)}`
}

export function buildChangePasswordUrl(returnTo?: string): string {
	return `${API_URL}/accounts/password/change/?next=${encodeURIComponent(absoluteUrl(returnTo))}`
}

let navigatingAway = false

export const isNavigatingAway = (): boolean => navigatingAway

export function navigateAway(url: string): void {
	navigatingAway = true
	window.location.replace(url)
}

function readBounceCount(): number {
	try {
		return Number.parseInt(window.sessionStorage.getItem(BOUNCE_COUNT_KEY) ?? "0", 10) || 0
	} catch {
		// Private browsing modes can make sessionStorage throw on access.
		// Losing the guard is survivable; crashing the only path back to a login page is not.
		return 0
	}
}

function writeBounceCount(count: number): void {
	try {
		window.sessionStorage.setItem(BOUNCE_COUNT_KEY, String(count))
	} catch {
		/* See readBounceCount. */
	}
}

export function clearLoginBounces(): void {
	try {
		window.sessionStorage.removeItem(BOUNCE_COUNT_KEY)
	} catch {
		/* See readBounceCount. */
	}
}

export function redirectToLogin(returnTo?: string): boolean {
	const bounces = readBounceCount() + 1

	if (bounces > MAX_BOUNCES) {
		console.error(
			`Refusing to send the browser to the login page again: it has bounced ${MAX_BOUNCES} times without a ` +
				"session being established. The session cookie is most likely being dropped between the two hosts.",
		)
		return false
	}

	writeBounceCount(bounces)
	navigateAway(buildLoginUrl(returnTo))
	return true
}

export function openLogin(returnTo?: string): void {
	clearLoginBounces()
	navigateAway(buildLoginUrl(returnTo))
}

export function openChangePassword(returnTo?: string): void {
	window.location.assign(buildChangePasswordUrl(returnTo))
}

export function untilPageUnloads(): Promise<never> {
	return new Promise<never>(() => {})
}
